import React, { Component } from 'react';
import { translate } from 'react-i18next';
import axios from 'axios';
import moment from 'moment-timezone';
import brandLogo from '../../images/brand-logo-inverse-light.png';

let cancelToken;
let state;
let tokenSession;


class RoomUpdateReservation extends Component {

    getInitState = () => {
        return {
            time: [],
            new_time: this.props.reservation.end_date,
            total_horas: " ",
            isNewDate: false
        }
    }

    constructor(props) {
        super(props);
        if (tokenSession !== props.getTokenSession()) {
            state = this.getInitState();
        }
        this.state = state;
    }
    componentWillMount() {
        cancelToken = axios.CancelToken.source();
    }

    componentDidMount() {
        this.reload();
    }

    componentWillUnmount() {
        cancelToken.cancel('Component will unmount.');
        state = this.state;
        tokenSession = this.props.getTokenSession();
    }

    componentDidUpdate(prevProps) {
        if (this.props.reservation.id !== prevProps.reservation.id) {
            this.reload();
        }
    }

    reload = () => {
        if(this.props.reservation){
            this.updateReservation({
                token_id: this.props.getTokenId(),
                token_session: this.props.getTokenSession(),
                reservation_id: this.props.reservation.id
            })
        }
    }

    updateRoomUpdate = (params) => {
        this.props.post(
            "/getUpdateReservation",
            params,
            (response) => this.didUpdateStatus(response),
            (error) => this.handleErrorResponsegetUpdateReservation(error),
            cancelToken
        );
    }

    updateReservation = (params) => {
        this.props.post(
            "/updatereservation",
            params,
            (response) => this.didGetTime(response),
            (error) => this.handleErrorResponse(error),
            cancelToken
        );
    }

    didGetTime = (response) => {
        this.setState({ time: response })
    }

    didUpdateStatus = (response) => {
        alert('RESERVACION ACTUALIZADA');
        this.setState({
            total_horas: " ",
            isNewDate: false,
        });
        this.reload();
        window.location.reload();
    }

    handleErrorResponse = (error) => {
        alert(error);
    }

    handleErrorResponsegetUpdateReservation = (error) => {
        console.error(error);
    }

    confirmarExtencionSala = (event) => {
        const new_time = moment(this.state.new_time).format('YYYY-MM-DD HH:mm');
        this.updateRoomUpdate({
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession(),
            reservation_id: this.props.reservation.id,
            new_time: new_time,
            old_time: this.props.reservation.end_date,
            start_time: this.props.reservation.start_date,
            correo: this.props.user.email
        });
    }


    handleTimeChange = (event) => {
        const total_new_time = event.target.value
        const old_time = moment(this.props.reservation.end_date)
        const newDate = event.target.value == 0 ? false : true
        this.setState({
            total_horas: event.target.value,
            isNewDate: newDate,
            new_time: old_time + (total_new_time * 60 * 60 * 1000)
        });
    }

    render() {
        const reservation = this.props.reservation
        const endDate = moment(reservation.end_date, 'YYYY-MM-DD HH:mm:ss');
        const startDate = moment(reservation.start_date, 'YYYY-MM-DD HH:mm:ss');
        const stat_data_form = moment(startDate).format('YYYY-MM-DD HH:mm');
        const end_data_form = moment(endDate).format('YYYY-MM-DD HH:mm');
        const new_time = moment(this.state.new_time).format('YYYY-MM-DD HH:mm');
        const { t } = this.props;
        return (
            <div>
                <button
                    className="hidden"
                    data-target="#modalSuccess"
                    data-toggle="modal"
                    id="btnSuccess"
                    type="button">
                </button>
                <div className="modal fade" id="modalSuccess" role="dialog">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header COVID-HEADER">
                                <button type="button" className="close btn-primary" data-dismiss="modal" aria-label="Close"><span aria-hidden="true" style={{ fontSize: '30px', background: 'red', width: '30px', display: 'block' }}>&times;</span></button>
                                <div className="navbar-header">
                                    <div className="navbar-brand">
                                        <img alt="IOS OFFICES" className="brand-logo" src={brandLogo} />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-body">
                                <h3>{t('dashboard.history.Extend_reservation')}</h3>
                                <div className="card-panel-body">
                                    <div className="form-group card-panel panel panel-default card center-block" style={{ display: 'block', padding: '10px' }}>
                                        <h5 className="ioscentro">{reservation.center_name}</h5>
                                        <h5 className="iossala">{reservation.name}</h5>

                                        <div className="panel-description-text">
                                            {reservation.description}
                                        </div>
                                        <div className="contenedor">
                                            <i className="fa fa-calendar" aria-hidden="true"></i>
                                            &ensp;
                                            {startDate.format('ll')}
                                        </div>
                                        <div className="contenedor">
                                            <i className="fa fa-clock-o" aria-hidden="true"></i>
                                            &ensp;
                                            {startDate.format('HH:mm')} - {endDate.format('HH:mm')}
                                        </div>
                                    </div>
                                    {this.state.time.length > 1 ? (
                                        <div className="form-group card-panel" style={{ display: 'block', padding: '10px' }}>
                                            <label htmlFor="time">
                                                {t('dashboard.history.Available_Hours')}
                                            </label>
                                            <select
                                                className="form-control"
                                                id="time"
                                                onChange={this.handleTimeChange}
                                                required
                                                value={this.state.total_horas}>
                                                {this.state.time.map((categoria, index) =>
                                                    categoria.id === 0 ? (
                                                        <option key={index} className="opcion-select" value={categoria.id}>Selecciona una opción</option>
                                                    ) : (<option key={index} className="opcion-select" value={categoria.id}>{categoria.name}</option>
                                                    )
                                                )}
                                            </select>
                                            <br></br>
                                            {this.state.isNewDate ? (
                                                <div className="form-group card-panel panel panel-default card center-block" style={{ display: 'block', padding: '10px' }}>
                                                    <h5 className="ioscentro" style={{ color: 'red' }}>{stat_data_form} - {end_data_form}</h5>
                                                    <h5 className="iossala">{stat_data_form} - {new_time}</h5>
                                                </div>
                                            ) : null}
                                            {this.state.time.length == 1 ? (
                                                <p>* No Hay Horas Disponibles *</p>
                                            ) : null}
                                        </div>
                                    ) : (
                                        <div>
                                            <p>* No Hay Horas Disponibles *</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    className="btn btn-default"
                                    data-dismiss="modal"
                                    type="button">
                                    {t('dashboard.profile.btn_close_balance')}
                                </button>
                                <button
                                    className="btn btn-primary"
                                    data-dismiss="modal"
                                    onClick={this.confirmarExtencionSala}
                                    type="button"
                                    disabled={this.state.isNewDate ? false : true}>
                                    {t('dashboard.history.Extend_reservation')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('common')(RoomUpdateReservation);


// WEBPACK FOOTER //
// ./src/dashboard/history/RoomUpdateReservation.js